<template>
    <div class="level">
        <button class="button is-small">
            {{ currentBid.group_name }}:
            {{ currentBid.max_wins }}
        </button>
    </div>
</template>

<script>
    import apiBids from '../../api/apiBids'
    export default {
        props:['bid'],
        data() {
            return {
                currentBid: {
                    id: this.bid.group.id,
                    user_id: this.bid.user_id,
                    bid_id: this.bid.id,
                    remarks: this.bid.group.remarks,
                    group_name: this.bid.group.name,
                    max_wins:  this.bid.group.max_wins,
                }
            }
        },
        methods: {
            bidGroupChange() {
                apiBids
                    .changeBidGroupRequest(this.currentBid)
                    .then((response) => {

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            bidGroupUpdate() {
                apiBids
                    .updateBidGroupRequest(this.currentBid)
                    .then((response) => {

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        created () {
            this.currentBid.group_name = this.bid.group.name
            this.currentBid.max_wins = this.bid.group.max_wins
            this.currentBid.id = this.bid.group.id
            this.currentBid.remarks = this.bid.group.remarks
            this.currentBid.user_id = this.bid.user_id
            this.currentBid.bid_id = this.bid.id
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Bids/BidGrpoup.vue